var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'flex items-center justify-between',
    { 'py-3 border-t border-gray-300': !_vm.small },
    { 'mb-2': _vm.small } ]},[_c('div',{staticClass:"text-gray-700"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }